export const types = {
  CLEAN_DASHBOARD: 'CLEAN_DASHBOARD',
  GET_CONFERENCES_LIST: {
    STARTED: 'GET_CONFERENCES_LIST_STARTED',
    FAILURE: 'GET_CONFERENCES_LIST_FAILURE',
    SUCCESS: 'GET_CONFERENCES_LIST_SUCCESS',
  },
  SET_CONFERENCES_FILTER: 'SET_CONFERENCES_FILTER',
  SET_CONFERENCES_ORDER: 'SET_CONFERENCES_ORDER',
  REGENERATE_PIN_FROM_DASHBOARD: {
    STARTED: 'REGENERATE_PIN_FROM_DASHBOARD_STARTED',
    FAILURE: 'REGENERATE_PIN_FROM_DASHBOARD_FAILURE',
    SUCCESS: 'REGENERATE_PIN_FROM_DASHBOARD_SUCCESS',
  },
  CANCEL_CONFERENCE_CALL: {
    STARTED: 'CANCEL_CONFERENCE_CALL_STARTED',
    FAILURE: 'CANCEL_CONFERENCE_CALL_FAILURE',
    SUCCESS: 'CANCEL_CONFERENCE_CALL_SUCCESS',
  },
  CALL_ATTENDEE: {
    STARTED: 'CALL_ATTENDEE.STARTED',
    FAILURE: 'CALL_ATTENDEE.FAILURE',
    SUCCESS: 'CALL_ATTENDEE.SUCCESS',
  },
};

export const cleanConferences = () => ({ type: types.CLEAN_DASHBOARD });

export const getConferencesList = (pageNumber, numberPerPage, filters) => ({
  type: types.GET_CONFERENCES_LIST.STARTED,
  pageNumber,
  numberPerPage,
  filters,
});

export const setConferencesFilter = (field, value) => ({
  type: types.SET_CONFERENCES_FILTER,
  field,
  value,
});

export const setConferencesOrder = (field, value) => ({
  type: types.SET_CONFERENCES_ORDER,
  field,
  value,
});

export const regeneratePinFromDashboard = (conferenceId) => ({
  type: types.REGENERATE_PIN_FROM_DASHBOARD.STARTED,
  conferenceId,
});

export const cancelConferenceCall = (conferenceId) => ({
  type: types.CANCEL_CONFERENCE_CALL.STARTED,
  conferenceId,
});

export const callAttendee = ({ conferenceId, id: attendeeId }) => ({
  type: types.CALL_ATTENDEE.STARTED,
  conferenceId,
  attendeeId,
});



// WEBPACK FOOTER //
// ./redux/actions/conferences.js